var $name="defaults",$path="configs/defaults.js",$this={$name,$path,};module.exports = {
  image: 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7',
  defaultDateFormat: 'dd-mm-yyyy',
};
